import { render, staticRenderFns } from "./imgview.vue?vue&type=template&id=547190d8&"
import script from "./imgview.vue?vue&type=script&lang=js&"
export * from "./imgview.vue?vue&type=script&lang=js&"
import style0 from "./imgview.vue?vue&type=style&index=0&id=547190d8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports